import React from 'react';
import { ShoppingBag, Truck, Phone } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';

const MenuEditor = ({ shippingCost, setShippingCost, notificationWhatsapp, setNotificationWhatsapp }) => {
  return (
    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-xl p-6" data-testid="menu-editor">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
          <ShoppingBag className="w-5 h-5 text-emerald-600" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-gray-950">Sistema de Pedidos</h3>
          <p className="text-xs text-gray-500">Configura el envio y numero donde recibiras los pedidos</p>
        </div>
      </div>

      {/* Notification WhatsApp Number */}
      <div className="mb-5">
        <Label className="text-gray-700 font-medium text-sm mb-2 flex items-center gap-2">
          <Phone className="w-4 h-4 text-emerald-600" />
          WhatsApp para recibir pedidos
        </Label>
        <Input
          value={notificationWhatsapp}
          onChange={(e) => setNotificationWhatsapp(e.target.value)}
          placeholder="+56912345678"
          data-testid="notification-whatsapp-input"
          className="bg-white border border-gray-200 rounded-lg px-4 py-2 focus:ring-2 focus:ring-emerald-500 text-gray-900 font-mono text-sm"
        />
        <p className="text-xs text-gray-400 mt-1">Formato internacional con +codigo de pais</p>
      </div>

      {/* Shipping Cost */}
      <div className="mb-4">
        <Label className="text-gray-700 font-medium text-sm mb-2 flex items-center gap-2">
          <Truck className="w-4 h-4 text-emerald-600" />
          Costo de envio ($)
        </Label>
        <Input
          type="number"
          value={shippingCost}
          onChange={(e) => setShippingCost(parseFloat(e.target.value) || 0)}
          placeholder="0"
          data-testid="shipping-cost-input"
          className="bg-white border border-gray-200 rounded-lg px-4 py-2 focus:ring-2 focus:ring-emerald-500 text-gray-900 w-32"
        />
      </div>

      <div className="bg-white/60 rounded-lg p-3 border border-emerald-100">
        <p className="text-xs text-emerald-700">
          Incluye tu menu de productos y precios en las <span className="font-semibold">Instrucciones del Asistente</span> (prompt). Cuando un cliente confirme un pedido, recibiras una notificacion por WhatsApp.
        </p>
      </div>
    </div>
  );
};

export default MenuEditor;
